<template>
    <!--完成画面-->
    <div class="preview-list">
        <div class="c-result__title">完成！</div>
        <canvas id="p1_canvas" width="3509" height="2481" class="" style="display: none"></canvas>
        <canvas id="p2_canvas" width="3509" height="2481" class="" style="display: none"></canvas>
        <canvas id="p3_canvas" width="3509" height="2481" class="" style="display: none"></canvas>
        <canvas id="p4_canvas" width="3509" height="2481" class="" style="display: none" v-if="this.mode != 'sa-rpa'"></canvas>
        <canvas id="p5_canvas" width="3509" height="2481" class="" style="display: none" v-if="this.mode != 'sa-rpa'"></canvas>
        <canvas id="p4_canvas" width="1920" height="1080" class="" style="display: none" v-if="this.mode == 'sa-rpa'"></canvas>
        <canvas id="p5_canvas" width="1920" height="1080" class="" style="display: none" v-if="this.mode == 'sa-rpa'"></canvas>
        <div class="preview-item c-result__image" v-if="this.generatedP1 && !this.isStandAlone"><img :src="generatedP1" alt="" /></div>
        <div class="preview-item c-result__image" v-if="this.generatedP2 && !this.isStandAlone"><img :src="generatedP2" alt="" /></div>
        <div class="preview-item c-result__image" v-if="this.generatedP3 && !this.isStandAlone"><img :src="generatedP3" alt="" /></div>
        <div class="preview-item c-result__image" v-if="this.generatedP4"><img :src="generatedP4" alt="" /></div>
        <div class="preview-item c-result__image" v-if="this.generatedP5"><img :src="generatedP5" alt="" /></div>
        <div class="w-100 py-5">
            <button type="button" class="button--download" @click="downloadPDF" v-if="downloadPDFEnable"><v-icon left dark> mdi-download </v-icon>ダウンロードする</button>
        </div>
    </div>
</template>

<script>
import { jsPDF } from "jspdf";

var WebFont = require("webfontloader");
WebFont.load({
    google: {
        families: ["Noto Sans JP"],
    },
    active: function () {
        // console.log("Google font is active.");
    },
});

export default {
    name: "SagasuPeterPan",
    props: {
        avatarCanvas: undefined,
        firstname: {
            type: String,
            required: false,
        },
        loadingContents: {
            type: Boolean,
            default: false,
        },
        BoySelected: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            required: true,
        },
        selectedPart: {
            type: Object,
            default: null,
            required: true,
        },
    },
    data() {
        return {
            generated: false,
            generatedP1: "",
            generatedP2: "",
            generatedP3: "",
            generatedP4: "",
            generatedP5: "",
            AvatarPosition: 1, //探すアバターの位置downloadPDFEnable: true,
            downloadPDFEnable: true,
            isStandAlone: false,
            avator_canvas: null,
        };
    },
    head: {
        link: [
            { rel: "preconnect", href: "https://fonts.googleapis.com" },
            { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: true },
            { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@700&display=swap" },
            { rel: "stylesheet", href: "https://fonts.googleapis.com/earlyaccess/roundedmplus1c.css" },
        ],
        script: [{ type: "text/javascript", src: "https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js" }],
    },
    async created() {
        // console.log("mode >> ", this.mode);
        switch (this.mode) {
            case "line":
                this.downloadPDFEnable = false;
                break;
            case "sa-rpa":
                this.isStandAlone = true;
                break;
            default:
                break;
        }
    },
    mounted() {
        console.log("Props: avatarCanvas", this.avatarCanvas);
        console.log("selectedPart >> ", this.selectedPart);
        this.setDefault();
    },
    methods: {
        setDefault: function () {
            this.generateImage();
        },
        generateImage: async function () {
            this.generated = true;
            console.log("1")
            this.avator_canvas = await this.avatarCanvas;
            await this.generateContent();
            setTimeout(this.previewContent, 3000);
            setTimeout(this.loadingClose, 5000);
        },
        Debug() {},
        async previewContent() {
            console.log("call : previewContent");
            //P1
            const $p1_canvas_new = await document.getElementById("p1_canvas");
            const p1_context_new = await $p1_canvas_new.getContext("2d");
            const base64_p1 = await p1_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP1 = await base64_p1;
            // console.log("done : ",this.generatedP1);
            // console.log("P! mode >>", this.mode);
            //P2
            const $p2_canvas_new = await document.getElementById("p2_canvas");
            const p2_context_new = await $p2_canvas_new.getContext("2d");
            const base64_p2 = await p2_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP2 = await base64_p2;
            // console.log("done : ",this.generated2);
            //P3
            const $p3_canvas_new = await document.getElementById("p3_canvas");
            const p3_context_new = await $p3_canvas_new.getContext("2d");
            const base64_p3 = await p3_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP3 = await base64_p3;
            // console.log("done : ",this.generatedP3);

            // let p4CanvasName = "p4_canvas";
            // let p5CanvasName = "p4_canvas";
            // if (this.mode == "sa-rpa") {
            //     p4CanvasName = "p4_canvas_rpa";
            //     p5CanvasName = "p5_canvas_rpa";
            // } else {
            //     p4CanvasName = "p4_canvas";
            //     p5CanvasName = "p4_canvas";
            // }
            // console.log("p4CanvasName >>",p4CanvasName)

            //P4
            const $p4_canvas_new = await document.getElementById("p4_canvas");
            console.log("$p4_canvas_new width >>", $p4_canvas_new.width);
            const p4_context_new = await $p4_canvas_new.getContext("2d");
            const base64_p4 = await p4_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP4 = await base64_p4;
            // console.log("done : ",this.generatedP4);
            //P5
            const $p5_canvas_new = await document.getElementById("p5_canvas");
            const p5_context_new = await $p5_canvas_new.getContext("2d");
            const base64_p5 = await p5_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP5 = await base64_p5;
            // console.log("done : ",this.generatedP5);

            console.log("done : previewContent");

            // this.downloadImage();
        },
        loadingClose: function () {
            // タイマーで動作させたい処理
            this.loading = false;
            this.$emit("loadingState", this.loading);
            console.log("done : loadingClose");
        },
        downloadImage: function () {
            // 生成した画像をダウンロードする
            console.log("call downloadImage");
            // const $canvas = document.getElementById("canvas");
            const $canvas = this.avatarCanvas;
            const $a = document.createElement("a");
            $a.href = $canvas.toDataURL("image/png");
            $a.download = "contents.png";
            $a.click();
        },
        generateContent: async function () {
            console.log("call : generateContent");
            //名前を生成
            var name = await this.firstname;
            //var name = 'いちじょう こうたろう';
            name = name.toUpperCase();

            //アバターキャンバスの読み込み
            // const avator = document.getElementById("canvas");
            const avator = await this.avator_canvas;
            // const avator = new Image();
            // var png = await this.avator_canvas.toDataURL();
            // avator.src = await png;

            //初期化
            var x_pos = 0;
            var y_pos = 0;
            var x_size = 0;
            var y_size = 0;
            var font_size = 0;
            var text = "";
            //初期化
            var textAreaWidth = 0;
            var textWidth = 0;

            //モード
            let LoadImages = [];
            let mode = this.mode;

            //P1*******************************************************************
            const $p1_canvas = document.getElementById("p1_canvas");
            const p1_context = $p1_canvas.getContext("2d");
            p1_context.clearRect(0, 0, $p1_canvas.width, $p1_canvas.height);
            const image_p1 = new Image();
            image_p1.src = require(`@/assets/img/contents/sagasu/background-sagasu-p1.jpg`);
            image_p1.onload = () => {
                //背景
                p1_context.drawImage(image_p1, 0, 0, $p1_canvas.width, $p1_canvas.height);
                //テキスト1-1
                font_size = 28;
                x_pos = 240;
                y_pos = 675 + 36;
                text = "ある日、まちをさんぽしていた " + name + " は";
                p1_context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                p1_context.fillStyle = "rgba(104, 53, 17)";
                p1_context.fillText(text, x_pos, y_pos);
                //テキスト1-2
                font_size = 28;
                x_pos = 1842;
                y_pos = 2043 + 36;
                text = name + " が　お店の中を　みましていると";
                p1_context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                p1_context.fillStyle = "rgba(104, 53, 17)";
                p1_context.fillText(text, x_pos, y_pos);
                console.log("done : p1");
            };

            //P2*******************************************************************
            const $p2_canvas = document.getElementById("p2_canvas");
            const p2_context = $p2_canvas.getContext("2d");
            p2_context.clearRect(0, 0, $p2_canvas.width, $p2_canvas.height);
            const image_p2 = new Image();
            const layer_p2 = new Image();
            const backhair_p2 = new Image();
            const body_p2 = new Image();
            if (this.BoySelected) {
                image_p2.src = require(`@/assets/img/contents/sagasu/background-sagasu-p2-boy.jpg`);
                backhair_p2.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
                body_p2.src = require("@/assets/img/contents/sagasu/background-sagasu-p2-boy_body.png");
                layer_p2.src = require("@/assets/img/contents/sagasu/background-sagasu-p2-layer.png");
            } else {
                image_p2.src = require(`@/assets/img/contents/sagasu/background-sagasu-p2-girl.jpg`);
                backhair_p2.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
                body_p2.src = require("@/assets/img/contents/sagasu/background-sagasu-p2-girl_body.png");
                layer_p2.src = require("@/assets/img/contents/sagasu/background-sagasu-p2-layer.png");
            }
            LoadImages = [image_p2, layer_p2, backhair_p2, body_p2];
            this.setLoadAllCallback(LoadImages, function () {
                //背景
                p2_context.drawImage(image_p2, 0, 0, $p2_canvas.width, $p2_canvas.height);

                //アバター1（後髪）
                x_pos = 610;
                y_pos = 1580;
                x_size = 437.52;
                y_size = 306.27;
                p2_context.rotate((-7.55 * Math.PI) / 180);
                p2_context.drawImage(backhair_p2, x_pos, y_pos, x_size, y_size);
                p2_context.rotate((7.55 * Math.PI) / 180);
                //アバター2（後髪）
                x_pos = 2017;
                y_pos = 1216.33;
                x_size = 702.67;
                y_size = 491.87;
                p2_context.drawImage(backhair_p2, x_pos, y_pos, x_size, y_size);
                //アバター1アバター2（体）
                p2_context.drawImage(body_p2, 0, 0, $p2_canvas.width, $p2_canvas.height);

                //アバター１
                x_pos = 610;
                y_pos = 1580;
                x_size = 437.52;
                y_size = 306.27;
                p2_context.rotate((-7.55 * Math.PI) / 180);
                p2_context.drawImage(avator, x_pos, y_pos, x_size, y_size);
                p2_context.rotate((7.55 * Math.PI) / 180);
                //アバター2
                x_pos = 2017;
                y_pos = 1216.33;
                x_size = 702.67;
                y_size = 491.87;
                p2_context.drawImage(avator, x_pos, y_pos, x_size, y_size);
                //テキスト2-1
                font_size = 28;
                x_pos = 174;
                y_pos = 266 + 43;
                text = "きがつくと " + name + " は　えほんの中に！";
                p2_context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                p2_context.fillStyle = "rgba(104, 53, 17)";
                p2_context.fillText(text, x_pos, y_pos);
                //テキスト2-2
                font_size = 28;
                x_pos = 1924;
                y_pos = 2055 + 42;
                text = "「" + name + " がどうわのせかいで　まいごになったぞ";
                p2_context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                p2_context.fillStyle = "rgba(104, 53, 17)";
                p2_context.fillText(text, x_pos, y_pos);
                console.log("done : p2");

                p2_context.drawImage(layer_p2, 0, 0, $p2_canvas.width, $p2_canvas.height);
            });

            //P3*******************************************************************
            const $p3_canvas = document.getElementById("p3_canvas");
            const p3_context = $p3_canvas.getContext("2d");
            p3_context.clearRect(0, 0, $p3_canvas.width, $p3_canvas.height);
            const image_p3 = new Image();
            const backhair_p3 = new Image();
            const body_p3 = new Image();
            LoadImages = [];
            if (this.BoySelected) {
                image_p3.src = require(`@/assets/img/contents/sagasu/background-sagasu-p3-boy.jpg`);
                backhair_p3.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
                body_p3.src = require("@/assets/img/contents/sagasu/background-sagasu-p3-boy_body.png");
            } else {
                image_p3.src = require(`@/assets/img/contents/sagasu/background-sagasu-p3-girl.jpg`);
                backhair_p3.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
                body_p3.src = require("@/assets/img/contents/sagasu/background-sagasu-p3-girl_body.png");
            }
            LoadImages = [image_p3, backhair_p3, body_p3];
            this.setLoadAllCallback(LoadImages, function () {
                //背景
                p3_context.drawImage(image_p3, 0, 0, $p3_canvas.width, $p3_canvas.height);

                //アバター1（後髪）
                x_pos = 357;
                y_pos = 692.73;
                x_size = 1052.67;
                y_size = 736.87;
                p3_context.drawImage(backhair_p3, x_pos, y_pos, x_size, y_size);

                //アバター1（体）
                p3_context.drawImage(body_p3, 0, 0, $p3_canvas.width, $p3_canvas.height);

                //アバター1
                x_pos = 357;
                y_pos = 692.73;
                x_size = 1052.67;
                y_size = 736.87;
                p3_context.drawImage(avator, x_pos, y_pos, x_size, y_size);

                //シール3-1（名前）
                x_pos = 500;
                y_pos = 412 + 90;
                font_size = 70;
                p3_context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                p3_context.fillStyle = "rgba(104, 53, 17)";
                textAreaWidth = 809;
                textWidth = p3_context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                p3_context.fillText(name, x_pos, y_pos, textAreaWidth);
            });
            console.log("done : p3");

            //P4*******************************************************************
            const $p4_canvas = document.getElementById("p4_canvas");
            const p4_context = $p4_canvas.getContext("2d");
            p4_context.clearRect(0, 0, $p4_canvas.width, $p4_canvas.height);
            const image_p4 = new Image();
            const backhair_p4 = new Image();
            const body_p4 = new Image();
            switch (mode) {
                case "sa-rpa":
                    image_p4.src = require("@/assets/img/contents/peterpan/background-sagasu-p4-peterpan-rpa.jpg");
                    backhair_p4.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
                    body_p4.src = require("@/assets/img/contents/peterpan/background-sagasu-p4-peterpan_body-rpa.png");
                    break;
                case "line":
                    image_p4.src = require(`@/assets/img/contents/sagasu/p4-line.jpg`);
                    backhair_p4.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
                    body_p4.src = require("@/assets/img/contents/peterpan/background-sagasu-p4-peterpan_body.png");
                    break;
                default:
                    image_p4.src = require(`@/assets/img/contents/peterpan/background-sagasu-p4-peterpan.jpg`);
                    backhair_p4.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
                    body_p4.src = require("@/assets/img/contents/peterpan/background-sagasu-p4-peterpan_body.png");
                    break;
            }
            LoadImages = [image_p4, backhair_p4, body_p4];
            this.setLoadAllCallback(LoadImages, function () {
                //背景
                p4_context.drawImage(image_p4, 0, 0, $p4_canvas.width, $p4_canvas.height);

                switch (mode) {
                    case "line":
                        p4_context.drawImage(image_p4, 0, 0, $p4_canvas.width, $p4_canvas.height);
                        break;
                    case "sa-rpa":
                        //アバター(参考)（後髪）
                        // x_pos = 540;
                        // y_pos = 520;
                        x_pos = 537;
                        y_pos = 505;
                        x_size = 347;
                        y_size = 243;
                        p4_context.rotate((-5.49 * Math.PI) / 180);
                        p4_context.drawImage(backhair_p4, x_pos, y_pos, x_size, y_size);
                        p4_context.rotate((5.49 * Math.PI) / 180);
                        //アバター1（体）
                        p4_context.drawImage(body_p4, 0, 0, $p4_canvas.width, $p4_canvas.height);
                        //アバター1
                        p4_context.rotate((-5.49 * Math.PI) / 180);
                        p4_context.drawImage(avator, x_pos, y_pos, x_size, y_size);
                        p4_context.rotate((5.49 * Math.PI) / 180);
                        //シール4-1（名前）
                        x_pos = 475;
                        y_pos = 288 + 45;
                        font_size = 36;
                        p4_context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                        p4_context.fillStyle = "rgba(104, 53, 17)";
                        textAreaWidth = 484;
                        textWidth = p4_context.measureText(name).width;
                        if (textAreaWidth < textWidth) {
                            //
                        } else {
                            x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                        }
                        p4_context.fillText(name, x_pos, y_pos, textAreaWidth);
                        break;
                    default:
                        //アバター(参考)（後髪）
                        x_pos = 400;
                        y_pos = 825;
                        x_size = 476;
                        y_size = 333.2;
                        p4_context.rotate((-5.49 * Math.PI) / 180);
                        p4_context.drawImage(backhair_p4, x_pos, y_pos, x_size, y_size);
                        p4_context.rotate((5.49 * Math.PI) / 180);
                        //アバター1（体）
                        p4_context.drawImage(body_p4, 0, 0, $p4_canvas.width, $p4_canvas.height);
                        //アバター1
                        x_pos = 400;
                        y_pos = 825;
                        x_size = 476;
                        y_size = 333.2;
                        p4_context.rotate((-5.49 * Math.PI) / 180);
                        p4_context.drawImage(avator, x_pos, y_pos, x_size, y_size);
                        p4_context.rotate((5.49 * Math.PI) / 180);
                        //シール4-1（名前）
                        x_pos = 420;
                        y_pos = 612 + 62;
                        font_size = 40;
                        p4_context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                        p4_context.fillStyle = "rgba(104, 53, 17)";
                        textAreaWidth = 524;
                        textWidth = p4_context.measureText(name).width;
                        if (textAreaWidth < textWidth) {
                            //
                        } else {
                            x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                        }
                        p4_context.fillText(name, x_pos, y_pos, textAreaWidth);
                        break;
                }

                console.log("done : p4");
            });

            //P5*******************************************************************
            const $p5_canvas = document.getElementById("p5_canvas");
            const p5_context = $p5_canvas.getContext("2d");
            p5_context.clearRect(0, 0, $p5_canvas.width, $p5_canvas.height);
            const image_p5 = new Image();
            const layer_p5 = new Image();
            const mixA_p5 = new Image();
            const mixB_p5 = new Image();
            const backhair_p5 = new Image();
            const body_p5 = new Image();
            const minibody_p5 = new Image();
            LoadImages = [];
            switch (mode) {
                case "sa-rpa":
                    image_p5.src = require("@/assets/img/contents/peterpan/background-sagasu-p5-peterpan-rpa.jpg");
                    layer_p5.src = require(`@/assets/img/contents/peterpan/front-sagasu-peterpan-1.png`);
                    mixA_p5.src = require(`@/assets/img/contents/peterpan/mix-sagasu-peterpan-a-rpa.png`);
                    mixB_p5.src = require(`@/assets/img/contents/peterpan/mix-sagasu-peterpan-b-rpa.png`);
                    backhair_p5.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
                    body_p5.src = require("@/assets/img/contents/peterpan/background-sagasu-p5-peterpan_body-rpa.png");
                    minibody_p5.src = require("@/assets/img/contents/peterpan/minibody-sagasu-p5-peterpan-rpa.png");
                    break;
                default:
                    image_p5.src = require(`@/assets/img/contents/peterpan/background-sagasu-p5-peterpan.jpg`);
                    layer_p5.src = require(`@/assets/img/contents/peterpan/front-sagasu-peterpan-1.png`);
                    mixA_p5.src = require(`@/assets/img/contents/peterpan/mix-sagasu-peterpan-a.png`);
                    mixB_p5.src = require(`@/assets/img/contents/peterpan/mix-sagasu-peterpan-b.png`);
                    backhair_p5.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
                    body_p5.src = require("@/assets/img/contents/peterpan/background-sagasu-p5-peterpan_body.png");
                    minibody_p5.src = require("@/assets/img/contents/peterpan/minibody-sagasu-p5-peterpan.png");
                    break;
            }
            LoadImages = [image_p5, layer_p5, mixA_p5, mixB_p5, backhair_p5, body_p5, minibody_p5];
            var AvatarPosition = this.AvatarPosition;
            // layer_p5.onload =  () => {
            this.setLoadAllCallback(LoadImages, function () {
                //背景
                p5_context.drawImage(image_p5, 0, 0, $p5_canvas.width, $p5_canvas.height);

                //アバター(参考)
                switch (mode) {
                    case "sa-rpa":
                        //アバター(参考)（後髪）
                        x_pos = 1661;
                        y_pos = 802;
                        x_size = 215.6;
                        y_size = 150.9;
                        p5_context.drawImage(backhair_p5, x_pos, y_pos, x_size, y_size);
                        //アバター1（体）
                        p5_context.drawImage(body_p5, 0, 0, $p5_canvas.width, $p5_canvas.height);

                        //アバター（参考）
                        p5_context.drawImage(avator, x_pos, y_pos, x_size, y_size);
                        break;
                    default:
                        //アバター(参考)（後髪）
                        x_pos = 2985;
                        y_pos = 205;
                        x_size = 383.64;
                        y_size = 268.55;
                        p5_context.drawImage(backhair_p5, x_pos, y_pos, x_size, y_size);
                        //アバター1（体）
                        p5_context.drawImage(body_p5, 0, 0, $p5_canvas.width, $p5_canvas.height);

                        //アバター（参考）
                        p5_context.drawImage(avator, x_pos, y_pos, x_size, y_size);
                        break;
                }

                if (AvatarPosition == 1) {
                    // console.log("AvatarPosition == 1");

                    switch (mode) {
                        case "sa-rpa":
                            //アバター1（後髪）
                            x_pos = 534;
                            y_pos = 909;
                            x_size = 108.6;
                            y_size = 78.38;
                            p5_context.rotate((-2.63 * Math.PI) / 180);
                            p5_context.drawImage(backhair_p5, x_pos, y_pos, x_size, y_size);
                            p5_context.rotate((2.63 * Math.PI) / 180);

                            //アバター1（体）
                            p5_context.drawImage(minibody_p5, 0, 0, $p5_canvas.width, $p5_canvas.height);

                            //アバター（位置1）
                            p5_context.rotate((-2.63 * Math.PI) / 180);
                            p5_context.drawImage(avator, x_pos, y_pos, x_size, y_size);
                            p5_context.rotate((2.63 * Math.PI) / 180);
                            break;
                        default:
                            //アバター1（後髪）
                            x_pos = 603;
                            y_pos = 2060;
                            x_size = 225.88;
                            y_size = 157.43;
                            p5_context.rotate((-2.63 * Math.PI) / 180);
                            p5_context.drawImage(backhair_p5, x_pos, y_pos, x_size, y_size);
                            p5_context.rotate((2.63 * Math.PI) / 180);

                            //アバター1（体）
                            p5_context.drawImage(minibody_p5, 0, 0, $p5_canvas.width, $p5_canvas.height);

                            //アバター（位置1）
                            p5_context.rotate((-2.63 * Math.PI) / 180);
                            p5_context.drawImage(avator, x_pos, y_pos, x_size, y_size);
                            p5_context.rotate((2.63 * Math.PI) / 180);
                            break;
                    }
                } else if (AvatarPosition == 2) {
                    // console.log("AvatarPosition == 2");
                    //アバター（位置2）
                    x_pos = 1088;
                    y_pos = 967;
                    x_size = 199.34;
                    y_size = 139.53;
                    p5_context.rotate((6.23 * Math.PI) / 180);
                    p5_context.drawImage(avator, x_pos, y_pos, x_size, y_size);
                    p5_context.rotate((-6.23 * Math.PI) / 180);
                } else if (AvatarPosition == 3) {
                    // console.log("AvatarPosition == 3");
                    //アバター（位置3）
                    x_pos = 1085;
                    y_pos = 685;
                    x_size = 179.49;
                    y_size = 125.64;
                    p5_context.rotate((-2.63 * Math.PI) / 180);
                    p5_context.drawImage(avator, x_pos, y_pos, x_size, y_size);
                    p5_context.rotate((2.63 * Math.PI) / 180);
                }

                //mixレイヤーA
                p5_context.globalCompositeOperation = "multiply";
                p5_context.drawImage(mixA_p5, 0, 0, $p5_canvas.width, $p5_canvas.height);

                //mixレイヤーB
                p5_context.globalCompositeOperation = "overlay";
                p5_context.drawImage(mixB_p5, 0, 0, $p5_canvas.width, $p5_canvas.height);

                //mix初期化
                p5_context.globalCompositeOperation = "source-over";

                //フロントレイヤー
                // p5_context.drawImage(layer_p5, 0, 0, $p5_canvas.width, $p5_canvas.height);
                console.log("done : p5");

                // name ="花";
                //シール5-1（名前）
                x_pos = 2980;
                y_pos = 150 + 62;
                font_size = 26;
                p5_context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                p5_context.fillStyle = "rgba(104, 53, 17)";
                textAreaWidth = 360;
                textWidth = p5_context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                p5_context.fillText(name, x_pos, y_pos, textAreaWidth);
                console.log("done : all");
            });

            console.log("done : generateContent");
        },
        setLoadAllCallback: function (elems, callback) {
            var count = 0;
            for (var i = 0; i < elems.length; ++i) {
                elems[i].onload = function () {
                    ++count;
                    if (count == elems.length) {
                        // All elements have been loaded.
                        callback(elems);
                    }
                };
            }
        },
        downloadPDF: function () {
            const pdf = new jsPDF("l", "pt", [3509, 2481], true);
            var width = pdf.internal.pageSize.width * 1;
            var height = pdf.internal.pageSize.height * 1;

            const p1_canvas = document.getElementById("p1_canvas");
            var p1_image_base64 = p1_canvas.toDataURL("image/jpeg", 0.6);
            const p1_image = new Image();
            p1_image.src = p1_image_base64;
            pdf.addImage(p1_image, "PNG", 0, 0, width, height, "", "FAST");

            pdf.addPage();

            const p2_canvas = document.getElementById("p2_canvas");
            var p2_image_base64 = p2_canvas.toDataURL("image/jpeg", 0.6);
            const p2_image = new Image();
            p2_image.src = p2_image_base64;
            pdf.addImage(p2_image, "PNG", 0, 0, width, height, "", "FAST");

            pdf.addPage();

            const p3_canvas = document.getElementById("p3_canvas");
            var p3_image_base64 = p3_canvas.toDataURL("image/jpeg", 0.6);
            const p3_image = new Image();
            p3_image.src = p3_image_base64;
            pdf.addImage(p3_image, "PNG", 0, 0, width, height, "", "FAST");

            pdf.addPage();

            const p4_canvas = document.getElementById("p4_canvas");
            var p4_image_base64 = p4_canvas.toDataURL("image/jpeg", 0.6);
            const p4_image = new Image();
            p4_image.src = p4_image_base64;
            pdf.addImage(p4_image, "PNG", 0, 0, width, height, "", "FAST");

            pdf.addPage();

            const p5_canvas = document.getElementById("p5_canvas");
            var p5_image_base64 = p5_canvas.toDataURL("image/jpeg", 1);
            const p5_image = new Image();
            p5_image.src = p5_image_base64;
            pdf.addImage(p5_image, "PNG", 0, 0, width, height, "", "FAST");

            var name = this.firstname;
            var fname = "SAGASU_EHON_" + name + ".pdf";
            pdf.save(fname);
        },
    },
};
</script>

<style>
@import "@/assets/css/app.css";
@import url("https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@700&display=swap");
</style>
